import nanoid from 'nanoid';

const save = payload => {
  const id = nanoid(6);
  localStorage.setItem(id, JSON.stringify(payload));

  return id;
};

const read = id => JSON.parse(localStorage.getItem(id));

const update = (id, payload) => {
  localStorage.setItem(id, JSON.stringify(payload));
};

const hasLearned = tip => {
  const learned = JSON.parse(localStorage.getItem('learned'));
  return learned && learned[tip];
};

const setLearned = tip => {
  let learned = JSON.parse(localStorage.getItem('learned'));
  if (!learned) {
    learned = {};
  }
  learned[tip] = true;
  localStorage.setItem('learned', JSON.stringify(learned));
};

export default {
  save,
  read,
  update,
  hasLearned,
  setLearned,
};
